import { ApiUtil, MediaNaviApiUtil } from '@/shared/api';

export const aiReviewApi = {
    /** AI 평어 조회 */
    getTchReportEvalGeneralReviewAiEvlWord: (param: API.TchReportGeneralReviewAiEvlWord.Req) => {
        // (평가) 총평 등록시 사용될 대단원 목록과 학생의 정답률에 따른 상/중/하 정보를 조회한다.
        return ApiUtil.get<API.TchReportGeneralReviewAiEvlWord.Res>(
            '/tch/report/eval/general-review/ai-evl-word',
            param
        );
    },

    /** AI 평어 생성 */
    postOverallReview: (param: API.OverallReview.Req) => {
        return MediaNaviApiUtil.post<API.OverallReview.Res>('/overall_review', param);
    },

    /** 평가 리포트 총평 저장 ( /tch/report/eval/general-review/save )*/
    postReportEvalReviewSave: (param: API.EvalReviewSave.Req) => {
        return ApiUtil.post<API.EvalReviewSave.Res>('/tch/report/eval/general-review/save', param);
    },

    /** 자주쓰는 문장 목록 조회 */
    getTchDsbdOftensentsList: (param: API.TchDsbdOftensentsList.Req) => {
        return ApiUtil.get<API.TchDsbdOftensentsList.Res>('/tch/dsbd/oftensents/list', param);
    },

    /** 자주쓰는 문장 등록 */
    postTchDsbdOftensentsSave: (param: API.TchDsbdOftensentsSave.Req) => {
        return ApiUtil.post<API.TchDsbdOftensentsSave.Res>('/tch/dsbd/oftensent/save', param);
    },

    /** 자주쓰는 문장 수정 */
    postTchDsbdOftensentsMod: (param: API.TchDsbdOftensentsMod.Req) => {
        return ApiUtil.post<API.TchDsbdOftensentsMod.Res>('/tch/dsbd/oftensent/mod', param);
    },

    /** 자주쓰는 문장 삭제 */
    postTchDsbdOftensentsDel: (param: API.TchDsbdOftensentsDel.Req) => {
        return ApiUtil.post<API.TchDsbdOftensentsDel.Res>('/tch/dsbd/oftensent/del', param);
    },

    /** 학생 총평 */
    getReportEvalReviewInfo: (param: API.EvalReviewInfo.Req) => {
        return ApiUtil.get<API.EvalReviewInfo.Res>('/tch/report/eval/general-review/info', param);
    },
};
